import cn from 'classnames';
import BaseModal from '@/components/modal/lib/BaseModal';
import LoginForm, {
  LoginFormProps
} from '@/components/form/LoginForm/LoginForm';

import './LoginModal.style.scss';

interface LoginModalProps extends LoginFormProps {
  className?: string;
  onClose: () => void;
}

function LoginModal(props: LoginModalProps) {
  const {
    headline,
    className = '',
    onClose,
    onSubmitSuccess,
    initialValues
  } = props;

  return (
    <BaseModal
      className={cn('LoginModal', className)}
      onClose={onClose}
    >
      <LoginForm
        headline={headline}
        initialValues={initialValues}
        onSubmitSuccess={onSubmitSuccess}
        onNavigateClick={() => {
          onClose();
        }}
      />
    </BaseModal>
  );
}

export default LoginModal;
